import React, { useEffect, useState } from 'react';
import { eventsAPI, unwrapList } from '../../services/api';
import { enqueue, flushQueue, readQueue } from '../../utils/offlineQueue';
import DeskStation from './DeskStation';
import { useLanguage } from '../../context/LanguageContext';

const GiftStation = () => {
  const { t } = useLanguage();
  const [batches, setBatches] = useState([]);
  const [batchId, setBatchId] = useState('');
  const [guestPhone, setGuestPhone] = useState('');
  const [guestName, setGuestName] = useState('');
  const [queued, setQueued] = useState(readQueue().length);

  const selected = batches.find((batch) => String(batch.id) === String(batchId));

  const send = (payload) => eventsAPI.redeem(payload).then((response) => response.data);

  useEffect(() => {
    eventsAPI.giftBatches().then((response) => {
      const rows = unwrapList(response.data).filter((batch) => batch.is_active);
      setBatches(rows);
      if (rows[0]) setBatchId(String(rows[0].id));
    }).catch(() => {});
    const flush = () => flushQueue((item) => {
      if (item.type !== 'redeem') return Promise.resolve();
      return send(item.payload);
    }).then(setQueued);
    window.addEventListener('online', flush);
    flush();
    return () => window.removeEventListener('online', flush);
  }, []);

  return (
    <DeskStation
      title={t('desk.giftTitle')}
      hint={`${t('desk.giftHint', { n: queued })}${selected?.remaining == null ? '' : ` ${t('desk.remaining', { n: selected.remaining })}`}`}
      selected={batchId}
      onSelect={setBatchId}
      options={batches.map((batch) => (
        <option key={batch.id} value={batch.id}>
          {batch.name}{batch.remaining == null ? '' : ` (${t('desk.remaining', { n: batch.remaining })})`}
        </option>
      ))}
      extra={(
        <>
          <label>{t('desk.guestPhone')}
            <input value={guestPhone} onChange={(event) => setGuestPhone(event.target.value)} />
          </label>
          <label>{t('desk.guestName')}
            <input value={guestName} onChange={(event) => setGuestName(event.target.value)} />
          </label>
        </>
      )}
      onScan={async (q) => {
        const payload = { q, gift_batch_id: batchId, guest_phone: guestPhone, guest_name: guestName };
        if (!navigator.onLine) {
          setQueued(enqueue({ type: 'redeem', payload }));
          return { color: 'yellow', message: t('desk.queued'), code: 'queued' };
        }
        try {
          return await send(payload);
        } catch (error) {
          if (!error.response) {
            setQueued(enqueue({ type: 'redeem', payload }));
            return { color: 'yellow', message: t('desk.queuedOffline'), code: 'queuedOffline' };
          }
          throw error;
        }
      }}
    />
  );
};

export default GiftStation;
